import '@miotech/iconfont';
import * as Sentry from '@sentry/react';
import { Route } from 'react-router-dom';

import { user } from './utils/user';
import Analytics from './utils/analytics';
import { uuid, parseQuery, copyToClipboard } from './utils/util';
import * as browserDetection from './utils/browserDetection';
import './utils/initSentry';

export { Sentry };

// --- components --- //
export { I18nWrapper, W, E, setLocale, getLocale, addResource, I18nContextProvider, useTranslation } from './i18n';
export type { TranslationFunctionType } from './i18n';
export { default as Avatar } from './Avatar/Avatar';
export { default as LoadingText } from './LoadingText/LoadingText';
export { default as ImmersivePopup } from './ImmersivePopup/ImmersivePopup';
export { default as TermsOfServicePopup } from './TermsOfServicePopup/TermsOfServicePopup';
export { default as AtomLoadingPopup } from './AtomLoadingPopup/AtomLoadingPopup';
export { default as Footer } from './Footer/Footer';
export { default as AtomLoading } from './AtomLoading/AtomLoading';
export { default as Table } from './Table/Table';
export { default as TableNext } from './TableNext/Table';
export { default as GeetestRecaptcha } from './GeetestRecaptcha/GeetestRecaptcha';
export { default as Marquee } from './Marquee/Marquee';
export { default as MainNavigationBarNext } from './MainNavigationBarNext/MainNavigationBarNext';
export { default as MainNav } from './MainNav/MainNav';
export {
  SubNavigationBar,
  SubNavigationBarWithBackButton,
} from './SubNavigationBar';
export { default as Authenticated } from './Authenticated/Authenticated';
export { default as AppAuthenticated } from './AppAuthenticated/AppAuthenticated';
export { default as Spin } from './Spin/Spin';
export { default as StencilLoading } from './StencilLoading/StencilLoading';
export {
  getHighchartsConfig,
  getHighchartsOptions,
} from './getHighchartsConfig';
export { API_INVALID_VALUE } from './utils/constant';
export { default as withBackUrl } from './withBackUrl';
export { default as RootErrorBoundary } from './RootErrorBoundary/RootErrorBoundary';
export { ErrorBoundary, withErrorBoundary } from './ErrorBoundary';
export type { ErrorBoundaryProps } from './ErrorBoundary';
export { default as BrowserCheck } from './BrowserCheck/BrowserCheck';
export { default as Pagination } from './Pagination/Pagination';
export { default as Accordion } from './Accordion/Accordion';
export { default as Collapsable } from './Collapsable/Collapsable';
export { default as TabNavBar } from './TabNavBar/TabNavBar';
export { default as PaperReport } from './PaperReport';

// --- pages --- //
export { default as PageWithFooter } from './pages/PageWithFooter/PageWithFooter';
export { default as UnsupportedBrowserPage } from './pages/UnsupportedBrowserPage/UnsupportedBrowserPage';
export { default as ErrorPage } from './pages/ErrorPage/ErrorPage';

// --- utils --- //
export { Analytics, uuid, parseQuery, copyToClipboard, browserDetection, user };
export {
  applicationMap,
  applications,
  allApplications,
  currentApplication,
  redirectToApplication,
  getUrlToApplication,
  getHostNameByApplicationId,
} from './utils/application';
export { hasPermission } from './utils/permissions';
export { default as formatter } from './utils/formatter';
export { getErrorMsg } from './utils/errorMsg';
export { default as PolicyAndServicePopup } from './PolicyAndServicePopup/PolicyAndServicePopup';
export const SentryRoute = Sentry.withSentryRouting(Route);
export { axios, instance, interceptAxios } from './utils/sentryAxios';
export type { SentryInterceptorOptions } from './utils/sentryAxios';
